import { render } from "./PagesList.vue?vue&type=template&id=f97ca8f2&scoped=true"
import script from "./PagesList.vue?vue&type=script&lang=js"
export * from "./PagesList.vue?vue&type=script&lang=js"

import "./PagesList.vue?vue&type=style&index=0&id=f97ca8f2&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f97ca8f2"]])

export default __exports__